// extracted by mini-css-extract-plugin
export default {"KeywordsBlock":"words-block_KeywordsBlock__1IfFo","AnalyticBlock":"words-block_AnalyticBlock__9SVrq"};